//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "battl_open",
  data() {
    return {
      animation_Interval: null,
      virtual_case_awards: [],
      curCount: 0,
    };
  },
  computed: {
    repeatNum() {
      const min = this.minCount;
      const length = this.items.length;
      return Math.floor(min / length);
    },
  },
  beforeDestory() {
    //clearInterval(this.animation_Interval)
  },
  created() {},
  mounted() {
    //this.animation_Interval = setInterval(this.CheckHotItem,100)
  },
  methods: {
    /** 乱序奖品池 */
    random_case_awards(items) {
      // 生成一轮奖品
      var result = Array(42)
        .fill(null)
        .map(() => items[parseInt(Math.random() * items.length)]);

      return result;
    },
    async reset(items, titem) {
      var randomItems = this.random_case_awards(items); //重置奖品
      randomItems[37] = titem;
      this.virtual_case_awards = randomItems;
      this.$refs.scroll.style.transition = "";
      this.$refs.scroll.style.marginTop = "";
    },
    async start(lotteryId, items) {
      var titem = items.find((item) => item.itemname === lotteryId);

      this.reset(items, titem);

      await this.$nextTick();
      setTimeout(() => {

        var main_roll = this.$refs.scroll;
        var award_hit_line = this.$refs.hitline;

        var award_opened = this.$refs.win_item[0];

        var move_pixel =
          award_opened.getBoundingClientRect().top -
          award_hit_line.getBoundingClientRect().top;
        var offset_pixel = Math.ceil(
          award_opened.getBoundingClientRect().height / 2
        );
        var move_pixel_real = move_pixel + offset_pixel;

        main_roll.style.transition = "all 5s cubic-bezier(.17,.67,.43,1)";
        main_roll.style.marginTop = `-${move_pixel_real}px`;
      }, 100);
    },
  },
};
